import React from "react";
import { FaTag, FaExchangeAlt } from "react-icons/fa";
import { Link } from "react-router-dom";


const grassImage = "/images/Grass.jpg";

const SwapOfferCard = ({ offer }) => {
  // Status colour matching MySwapDeals card
  const isCleaning = offer.category === "cleaning";
  const getStatusColor = (status) => {
    if (!status) return "#555";

    switch (status.toLowerCase()) {
      case "pending":
        return "#f9a825";
      case "accepted":
        return "green";
      case "declined":
        return "red";
      default:
        return "#555";
    }
  };

  return (
    <div
      style={{
        background: "#fff",
        padding: "15px",
        borderRadius: "12px",
        border: "1px solid #e0e0e0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        marginBottom: "20px",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "8px",
        }}
      >
        <h3 style={{ margin: 0 }}>Your Swap Offer</h3>

        <div
          style={{
            display: "inline-flex",
            padding: "4px 10px",
            backgroundColor: "#e3f2fd",
            color: "#0277bd",
            borderRadius: "20px",
            fontSize: "13px",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <FaExchangeAlt /> Sent
        </div>
      </div>

      {/* IMAGE */}
      <img
        src={offer.image || grassImage}
        alt="swap preview"
        style={{
          width: "100%",
          height: "160px",
          objectFit: "cover",
          borderRadius: "10px",
          marginBottom: "10px",
        }}
      />

      {/* OFFER ID */}
      <div style={{ marginBottom: "8px", fontSize: "14px", color: "#555" }}>
        <FaTag /> <strong>{offer.swapListingId}</strong>
      </div>

      {/* FROM / TO BOX — identical to deal card styling */}
      <div
        style={{
          background: "#f9f9f9",
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #eee",
          marginBottom: "10px",
          fontSize: "14px",
        }}
      >
        <strong>From:</strong> {offer.fromSuburb} {offer.fromPostcode}
        <br />
        <strong>To:</strong> {offer.toSuburb} {offer.toPostcode}
      </div>

      {/* STATUS */}
      <div
        style={{
          marginTop: "12px",
          fontSize: "14px",
          fontWeight: "bold",
          color: getStatusColor(offer.status),
          textTransform: "capitalize",
        }}
      >
        Status: {offer.status}
      </div>

      {/* BUTTON */}
      <div style={{ marginTop: "12px", display: "flex" }}>
        <Link
  to={
    isCleaning
      ? `/cleaning/swaps/${offer.swapListingId}`
      : `/swap/${offer.listingInternalId}`
  }
  style={{ flex: 1, textDecoration: "none" }}
>

          <button
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "8px",
              border: "none",
              fontSize: "14px",
              cursor: "pointer",
              backgroundColor: "#0288d1",
              color: "#fff",
            }}
          >
            View Details
          </button>
        </Link>
      </div>
    </div>
  );
};

export default SwapOfferCard;
